import {ApplicationStoreType} from 'desktop/store';

import {MODULE_KEY_SUCCESS} from '../../constants';

/**
 * Get loading state for one time coupon
 * @param {ApplicationStoreType} store - The application store
 * @returns {boolean} - Whether the one time coupon is loading
 */
export const getIsOneTimeCouponLoading = (store: ApplicationStoreType): boolean =>
    store[MODULE_KEY_SUCCESS].oneTimeCoupon.isLoading;

/**
 * Get the one time coupon code
 * @param {ApplicationStoreType} store - The application store
 * @returns {string} - The one time coupon code
 */
export const getOneTimeCouponCode = (store: ApplicationStoreType): string =>
    store[MODULE_KEY_SUCCESS].oneTimeCoupon.couponCode;
